import { UserStatus } from '@edgebox/data-definitions';
import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { DataDefinitionsEnumValue } from '../../Localization/DataDefinitionsEnumValue';

interface IProps {
  status: UserStatus;
}

export class UserStatusBadge extends React.Component<IProps, {}> {
  render(): React.ReactElement {
    const { status } = this.props;

    const classes = 'opacity-3';

    const variants = {
      [UserStatus.Invited]: 'info',
      [UserStatus.VerifyEmail]: 'warning',
      [UserStatus.Active]: 'primary',
      [UserStatus.Inactive]: 'dark',
    };

    return (
      <Badge bg={variants[status]} className={classes}>
        <DataDefinitionsEnumValue enumName={'UserStatus'} keyName={status} />
      </Badge>
    );
  }
}
